import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Checkbox = (props) => {
  const { checked, id, className, labelText, onChange } = props;

  const checkboxClassName = cn('label', className);

  return (
    <label className={checkboxClassName}>
      <input id={id} type="checkbox" onChange={onChange} checked={checked} />
      {labelText}
    </label>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
  className: '',
};
